import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './cart/cart';
import './cart/cart-utils';
import './sliders/product-slider';
import './sliders/slider-featured.js';
import './sliders/slider-showcase.js';
import './sliders/slider-products.js';
import './sliders/slider-hero.js';
import './product/ajax-actions';
import './product/quantity';
import './product/pdp-variant-select.js';
import './product/get-related-products.js';
import './modules/search-bar-handler.js';
import './modules/mobile-nav-handler.js';
import './polyfills/object-fit.js';
import './polyfills/smooth-scroll-polyfill.js';
import './modules/map-google.js';
import './modules/ajax-recent-posts';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed


$('.js-reload-script').on('click', function(event) {
	event.preventDefault()

	codeblackbelt = null

	const scriptSrc = '//cdn.codeblackbelt.com/js/modules/shipping-rates-calculator-plus/main.min.js?shop=taylor-maid-farms.myshopify.com'
	const $script = $('head script')[0];

	const newScript = $($script).clone()

	$('body').append(newScript)
});